import styled from "styled-components"
import { device } from "../../utils/breakpoints.js"
import quoteMark from "images/quoteMark.svg"

export const ContentWrapper = styled.div`
  /* border-bottom: 1px solid #dce0e7; */
  /* border-bottom: ${props => !props.content && "none"}; */
  margin-top: 27px;
  margin-top: ${props => props.landing && 0};
  margin-bottom: 10px;

  @media ${device.desktop} {
    margin-top: 32px !important;
    margin-top: ${props => props.landing && "10px"}!important;

    width: 759px;
    margin: 0 auto;
    margin-bottom: 30px;
  }


  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 22px;
    font-weight: 600;
    color: #2a3449;

    @media ${device.desktop} {
      margin-bottom: 37px;
    }
  }

  h2 {
    font-size: 28px;
    letter-spacing: -0.75px;
    line-height: 28px;

    @media ${device.desktop} {
      font-size: 36px;
      letter-spacing: -0.56px;
      line-height: 40px;
      margin-bottom: 38px;
    }
  }

  h3 {
    font-size: 24px;
    letter-spacing: -0.38px;
    line-height: 28px;
    margin-bottom: 15px;
    @media ${device.desktop} {
      font-size: 32px;
      letter-spacing: -0.5px;
      line-height: 36px;
      margin-bottom: 27px;
    }
  }

  h4 {
    font-size: 22px;
    letter-spacing: -0.34px;
    line-height: 28px;
    margin-bottom: 16px;
    @media ${device.desktop} {
      font-size: 28px;
      letter-spacing: -0.44px;
      line-height: 36px;
      margin-bottom: 24px;
    }
  }

  h5 {
    font-size: 20px;
    letter-spacing: -0.31px;
    line-height: 28px;
    margin-bottom: 16px;
    @media ${device.desktop} {
      font-size: 24px;
      letter-spacing: -0.38px;
      line-height: 30px;
      margin-bottom: 25px;
    }
  }

  h6 {
    font-size: 24px;
    @media ${device.desktop} {
      font-size: 30px;
    }
  }

  /* h6 {
    font-size: 20px;
    @media ${device.desktop} {
      font-size: 26px;
    }
  } */

  p {
    font-weight: 400;
    font-size: 16px;
    color: #5c6370;
    letter-spacing: -0.25px;
    line-height: 24px;
    margin-bottom: 25px;

    @media ${device.desktop} {
      font-size: 18px;
      letter-spacing: -0.28px;
      line-height: 27px;
    }

    &:first-of-type {
      color: #2a3449;
      font-size: 20px;
      margin-bottom: 15px;

      @media ${device.desktop} {
        font-size: 24px;
        letter-spacing: -0.76px;
        line-height: 32px;
        margin-bottom: 35px;
      }
    }

    a {
      display: inline;
      position: relative;
      color: #2a3449;
      font-weight: 600;
      background-image: linear-gradient(
        to right,
        ${props => props.theme.linkColor},
        ${props => props.theme.linkColor}
      );
      background-position: 0 100%;
      background-repeat: no-repeat;
      background-size: 100% 2px;
      :hover {
        background-image: none;
      }
    }
  }

  li  a {
      display: inline;
      position: relative;
      color: #2a3449;
      font-weight: 600;
      background-image: linear-gradient(
        to right,
        ${props => props.theme.linkColor},
        ${props => props.theme.linkColor}
      );
      background-position: 0 100%;
      background-repeat: no-repeat;
      background-size: 100% 2px;
      :hover {
        background-image: none;
      }
    }

  ul {
    margin-left: 22px;
    margin-bottom: 35px;

    li {
      font-weight: 400;
      font-size: 16px;
      color: #5c6370;
      letter-spacing: -0.25px;
      line-height: 24px;
      list-style-type: none;
      position: relative;
      margin-bottom: 16px;

      @media ${device.desktop} {
        font-size: 18px;
        letter-spacing: -0.28px;
        line-height: 27px;
        margin-bottom: 17px;
      }

      ::before {
        content: "";
        height: 4px;
        width: 4px;
        background-color: ${props => props.theme.primaryColor};
        display: block;
        position: absolute;
        top: 10px;
        left: -21px;

        @media ${device.desktop} {
          top: 10px;
          font-size: 20px;
        }
      }
    }
  }

  > ol {
    list-style: none;
    counter-reset: ordered-list;
    margin-bottom: 34px;

    @media ${device.desktop} {
      margin-bottom: 62px;
    }
  }
  > ol li {
    font-weight: 400;
    font-size: 16px;
    color: #5c6370;
    letter-spacing: -0.25px;
    line-height: 24px;

    counter-increment: ordered-list;
    position: relative;
    margin-left: 21px;
    margin-bottom: 16px;

    @media ${device.desktop} {
      font-size: 18px;
      letter-spacing: -0.28px;
      line-height: 27px;
      margin-left: 30px;
      margin-bottom: 18px;
    }

    :after {
      content: counter(ordered-list);
      font-weight: bold;
      font-size: 16px;
      color: ${props => props.theme.primaryColor};
      letter-spacing: -0.16px;
      line-height: 24px;
      border-radius: 6px;
      position: absolute;
      top: -3px;
      left: -20px;
      @media ${device.desktop} {
        font-size: 18px;
        top: 2px;
        left: -32px;
      }
    }
  }

  iframe {
    max-width: 100% !important;
  }

  figure.wp-block-image {
    margin: 36px auto;
    position: relative;
  }
  div.wp-block-image,
  figure.wp-block-image {
    margin: 34px auto;

    @media ${device.desktop} {
      margin: 51px auto;
      margin-bottom: 52px;
    }

    img {
      margin: 0;
      display: block;
      width: 100%;
      height: auto;
    }

    figcaption {
      margin-top: 6px;
      font-size: 12px;
      font-weight: 500;

      @media ${device.desktop} {
        font-size: 16px;
        color: #4c4d58;
        position: absolute;
        left: 0;
        bottom: -54px;
        padding-left: 0;
        padding-bottom: 16px;
        padding-top: 19px;
        margin-top: 0px;
        width: 100%;
        z-index: 1;
      }
    }
  }

  div.wp-block-embed__wrapper {
    position: relative;
    padding-top: 56.25%;
    margin-bottom: 35px;

    @media ${device.desktop} {
      margin-bottom: 55px;
    }

    > iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  div.wp-block-image {
    figure.alignleft {
      margin: 36px auto;

      img {
        display: block;

        width: 100%;
      }

      @media ${device.desktop} {
        float: left;
        width: calc(50% - 30px);
        margin-top: 0;
        margin-right: 60px;
        margin-bottom: 30px;
      }
    }
  }

  blockquote {
    position: relative;
    width: calc(100% + 60px);
    margin: 40px 0 40px -30px;
    padding: 115px 30px 70px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    @media ${device.tablet} {
      padding: 130px 30px 100px;
    }
    @media ${device.desktop} {
      width: 100%;
      margin: 70px 0 70px 0;
      padding: 112px 74px 75px;
    }

    :before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      background: ${props => props.theme.navy};
      clip-path: polygon(0 73px, 200% 0, 196% calc(100% - 73px), 0 100%);

      @media ${device.tablet} {
        clip-path: polygon(0 73px, 100% 0, 100% calc(100% - 73px), 0 100%);
      }

      @media ${device.desktop} {
        clip-path: polygon(0 65px, 100% 0, 100% calc(100% - 65px), 0 100%);
      }
    }

    :after {
      content: "";
      height: 56px;
      width: 55px;
      position: absolute;
      top: 30px;
      left: 31px;
      transform: scale(1);
      background-image: url(${quoteMark});
      background-repeat: no-repeat;

      @media ${device.tablet} {
        top: 37px;
      }

      @media ${device.desktop} {
        transform: scale(1.4);
        left: 80px;
        top: 15px;
      }
    }

    p {
      font-weight: 400 !important;
      font-size: 18px !important;
      color: #ffffff !important;
      letter-spacing: -0.28px !important;
      line-height: 28px !important;
      position: relative;
      z-index: 1 !important;
      font-style: italic;
      display: block;
      width: 100%;

      @media ${device.desktop} {
        font-size: 24px !important;
        letter-spacing: -0.38px !important;
        line-height: 32px !important;
        width: 90%;
      }
    }
    p {
      :before {
        content: "“";
      }
      :after {
        content: "”";
      }
    }
    cite {
      font-style:normal;
      font-weight: 600;
      font-size: 12px;
      color: #ffffff;
      letter-spacing: -0.19px;
      line-height: 27px;
      display: block;
      padding-left: 42px;
      position: relative;
      width: 100%;

      @media ${device.desktop} {
        font-size: 14px;
        letter-spacing: -0.22px;
        line-height: 27px;
      }
      ::before {
        content: "";
        position: absolute;
        top: 14px;
        left: 0;
        width: 24px;
        height: 2px;
        background: #f17071;

        @media ${device.desktop} {
          width: 32px;
        }
      }
    }
  }
`
